export const NormalizedPredictionKind = Object.freeze({
    NONE: "NONE",
    NORMAL: "NORMAL",
    MOON_CHANGE: "MOON_CHANGE",
    UNKNOWN: "UNKNOWN"
});
